import { IPaginationParams, IPaginationResponse } from '../models/interfaces/pagination';
import { IReservation } from 'src/models/interfaces/reservation';

import apiService from './api';

export class ReservationService {
  public report(params: IPaginationParams): Promise<IPaginationResponse<IReservation[]>> {
    return apiService.get('/reservation/report', { params });
  }

  public cancel(reservationIds: number[]): Promise<void> {
    return apiService.post('/reservation/cancel', { reservationIds });
  }

  public exportReport(params: IPaginationParams) {
    return apiService.get('/reservation/report/download', { responseType: 'blob', headers: { 'Accept': 'application/vnd.ms-excel' }, params });
  }
}

const reservationService = new ReservationService();
export default reservationService;